import $ from 'jquery';
// import mpro from './mpro.init';

// ===================================
// Custom Form plugins
// ===================================

/**
 * Make inputs grow/shrink automatically
 *
 * @param {JQuery} $toggleButton
 */
mpro.handlePasswordToggle = function($toggleButton) {

	if (!($toggleButton instanceof $)) {
		$toggleButton = $($toggleButton);
	}

	$toggleButton.each(function() {
		const $btn = $(this);
		const data = $btn.data('toggle-pw');
		const $input = $btn.parent().find(data.target || 'input[type="text"],input[type="password"]');
		const $B = mpro.get$B();
		const dotsMode = ($input.attr('type') === 'password') ? false : true;
		const dotsClass = data.dotsClass || 'form-control-disc';
		const activeClass = data.activeClass || 'active';

		const onHandler = () => {
			if (dotsMode) {
				$input.removeClass(dotsClass);
			}
			else {
				$input.prop('type', 'text');
			}
		};

		const offHandler = () => {
			if (dotsMode) {
				$input.addClass(dotsClass);
			}
			else {
				$input.prop('type', 'password');
			}
		};

		// Make sure defaults are set
		if (dotsMode) {
			offHandler();
		}
		// Make sure the input doesn't have the dots class
		else {
			$input.removeClass(dotsClass);
		}

		// Doesn't required holding the mouse button pressed
		if (data.toggleMode === 'alternate') {
			$btn.on('click.pw-toggle', (e) => {
				e.preventDefault();

				if ($btn.hasClass(activeClass)) {
					$btn.removeClass(activeClass);
					offHandler();
				}
				else {
					$btn.addClass(activeClass);
					onHandler();
				}
			});
		}
		// Password is shown only when the mouse button is hold
		else {
			$btn.on('mousedown.pw-toggle touchstart.pw-toggle', (e) => {
				// Note: do not preventDefault() on mobile
				onHandler();

				$B.one('mouseup.pw-toggle touchend.pw-toggle', (e) => {
					e.preventDefault();
					offHandler();
				});
			});
		}
	});
};


/**
 * @param {JQuery} $container
 */
mpro.addFormPlugins = ($container) => {

	// Password toggle
	mpro.handlePasswordToggle($container.find('[data-toggle-pw]'));
};

export default mpro;
